import React from 'react';
import { IoMdAddCircle } from 'react-icons/io';
import styled from 'styled-components';

const UserPic = ({ src, onClick }: { onClick: () => void; src: string }) => (
	<Wrapper onClick={onClick}>
		<img src={src} alt="user profile pic" />
		<div>
			<IoMdAddCircle size={13} color="#A4A6A8" />
		</div>
	</Wrapper>
);

export default UserPic;

const Wrapper = styled.div`
	position: relative;
	width: 40px;
	height: 40px;
	cursor: pointer;

	img {
		border-radius: 50%;
		overflow: hidden;
	}

	div {
		position: absolute;
		bottom: 0;
		right: 0;
		border-radius: 50%;
		width: 14px;
		height: 14px;
		background-color: white;
	}
`;
